export default __webpack_public_path__ + "static/media/map.94da739e.png";